export enum GameCollection {
  ARK_NOVA = "ark-nova",
  WINGSPAN = "wingspan",
  TERRA_MYSTICA = "terra-mystica",
  MARCO_POLO = "marco-polo",
  CHALLENGERS = "challengers",
}
